export default {
  data () {
    return {
      search: '',
      filters: {
        searchText: '',
        selectedObject: null
      }
    }
  },
  methods: {
    sanitize (text) {
      return text.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    getObjectValue (object, path) {
      var paths = path.split('.')
      var current = object
      var i

      for (i = 0; i < paths.length; ++i) {
        if (current[paths[i]] === undefined || !current[paths[i]]) {
          return null
        } else {
          current = current[paths[i]]
        }
      }
      return current
    },
    searchVisibleKeys (object, search) {
      const context = this
      const visibleHeaders = this.headers.filter((h) => h.show)
      return visibleHeaders.some(header => {
        return context.sanitize(this.getObjectValue(object, header.path) || '').indexOf(search) !== -1
      })
    },
    searchKeys (object, search) {
      const context = this
      var matchesDateFormat = new RegExp(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/)
      return Object.keys(object).some(function (k) {
        if (object[k] === null) return false
        if (typeof object[k] === 'object') {
          return context.searchKeys(object[k], search)
        } else if (typeof object[k] === 'string' && matchesDateFormat.test(object[k])) {
          return window.moment(object[k]).local().format('DD/MM/YYYY HH:mm').indexOf(search) !== -1
        } else {
          return context.sanitize(object[k]).indexOf(search) !== -1
        }
      })
    },
    autocompleteFilter (item, queryText, itemText) {
      queryText = this.sanitize(queryText)
      return this.sanitize(itemText).indexOf(queryText) !== -1
    },
    textSearchByVisibleValues (items, search, filter) {
      if (search.trim() === '') {
        return items
      }
      const context = this
      search = this.sanitize(search)
      return items.filter(function (o) {
        return context.searchVisibleKeys(o, search)
      })
    },
    textSearchByValues (items, search, filter) {
      if (search.trim() === '') {
        return items
      }
      const context = this
      search = this.sanitize(search)
      return items.filter(function (o) {
        return context.searchKeys(o, search)
      })
    },
    filterBySelectionAndText (items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers)
      const context = this
      cf.registerFilter('selectedObject', function (selectedObject, items) {
        if (!selectedObject) return items
        if (!!selectedObject.key && !!selectedObject.val) {
          if (Array.isArray(selectedObject.val)) {
            return items.filter(function (o) {
              return selectedObject.val.includes(context.getObjectValue(o, selectedObject.key))
            })
          } else {
            return items.filter(function (o) {
              return o[selectedObject.key] === selectedObject.val
            })
          }
        } else {
          return items.filter(function (o) {
            return Object.keys(o).some(function (k) {
              return o[k] && JSON.stringify(o[k]) === JSON.stringify(selectedObject)
            })
          })
        }
      })
      cf.registerFilter('searchText', function (searchText, items) {
        return context.textSearchByVisibleValues(items, searchText, filter)
      })

      return cf.runFilters()
    },
    filterByText (val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, { searchText: val })
    },
    filterBySelector (val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, { selectedObject: val })
    }
  }
}
